const setRoles = (state, obj) => {
  state.roles = obj
}

const setSelectedRole = (state, obj) => {
  state.selectedRole = obj
}

const setPermissions = (state, obj) => {
  state.permissions = obj
}

const setAllPermissions = (state, obj) => {
  state.allPermissions = obj
}

const setPermissionsPage = (state, obj) => {
  state.permissions_page = obj
}
const setPermissionsPages = (state, obj) => {
  state.permissions_pages = obj
}

export default {
  setRoles,
  setSelectedRole,
  setPermissions,
  setAllPermissions,
  setPermissionsPage,
  setPermissionsPages
}